export default "__VITE_ASSET__PCI83H8G__"